import { createRatesGlobalRequest } from "../../data/ratesGlobalApi";
import { validateTarifaGlobalEnterprisePayload } from "../validator/validateTarifaGlobalEnterprisePayload";

export async function createTarifaGlobalEnterpriseUseCase(payload) {
  const error = validateTarifaGlobalEnterprisePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createRatesGlobalRequest(payload);
}
